import { IAppState } from '../../common/state';

export function getNewbuildingIdsForBuildersPromoSlider({ newbuildingIdsForBuildersPromoSlider }: IAppState) {
  return newbuildingIdsForBuildersPromoSlider;
}
